import styled from 'styled-components';
import { Box, Typography, Link } from '@mui/material';
import placeholderImage from '../../../images/JamesProfileSignUpPage.jpeg';

export const LandingContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  @supports (height: 100dvh) {
    min-height: 100dvh;
  }
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  
  @media (min-width: 901px) {
    flex-direction: row;
    overflow-y: auto;
    height: 100vh;
    height: 100svh;
    @supports (height: 100dvh) {
      height: 100dvh;
    }
    align-items: stretch;
    padding: 0;
    -webkit-overflow-scrolling: touch;
    max-width: 1400px;
    margin: 0 auto;
  }
`;

export const FormContainer = styled.div`
  padding: calc(1rem + var(--native-safe-area-top, env(safe-area-inset-top, 0px))) 1rem 1rem;
  box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: auto;

  @media (min-width: 768px) {
    padding: 1.5rem 2rem;
  }

  @media (min-width: 901px) {
    padding: 1.75rem 3rem;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 100vh;
    min-height: 100svh;
    @supports (height: 100dvh) {
      min-height: 100dvh;
    }
    order: 1;
    flex: 0 0 auto;
    width: 50%;
    max-width: 580px;
    overflow-y: auto;
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 0.375rem;
  /* Keep the introduction, divider, and form together. */
  min-height: auto;
  justify-content: flex-start;

  @media (max-width: 360px) {
    gap: 0.25rem;
  }

  @media (min-width: 768px) {
    gap: 0.375rem;
    /* Parent padding increases to 1.5rem each side */
    /* On tablet, avoid large vertical gaps by letting content size naturally */
    min-height: auto;
    justify-content: flex-start;
    /* Widen content on iPad Mini/Air to use screen width better */
    max-width: 500px;
  }

  @media (min-width: 901px) {
    align-items: flex-start;
    text-align: left;
    max-width: 480px;
    gap: 0;
    width: 100%;
    /* Center when there is room; anchor at the top when the form overflows. */
    margin: auto 0;
    height: auto;
    /* On tablets and small laptops, avoid forced spacing */
    min-height: auto;
    justify-content: center;
  }
  
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
  width: 100%;

  @media (max-width: 400px) {
    gap: 0.25rem;
  }

  @media (max-width: 360px) {
    gap: 0.125rem;
  }

  @media (min-width: 768px) {
    gap: 0.375rem;
  }

  @media (min-width: 901px) {
    gap: 0.25rem;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
  width: 100%;

  @media (max-width: 400px) {
    gap: 0.25rem;
  }

  @media (max-width: 360px) {
    gap: 0.125rem;
  }

  @media (min-width: 768px) {
    gap: 0.375rem;
  }

  @media (min-width: 901px) {
    gap: 0.375rem;
  }
`;

export const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 0.25rem 0;
  
  @media (max-width: 400px) {
    margin: 0.25rem 0;
  }

  @media (max-width: 360px) {
    margin: 0.125rem 0;
  }

  @media (min-width: 768px) {
    margin: 0.25rem 0;
  }

  @media (min-width: 901px) {
    margin: 0;
  }
`;

export const ImageContainer = styled.div`
  display: none;

  @media (min-width: 901px) {
    display: block;
    flex: 1;
    background: url(${placeholderImage}) no-repeat center center;
    background-size: cover;
    order: 2;
    min-height: 100vh;
    min-height: 100svh;
    @supports (height: 100dvh) {
      min-height: 100dvh;
    }
    align-self: stretch;
  }
`;

export const MobileImage = styled.img`
  display: block;
  width: 100%;
  max-width: 400px;
  margin-top: 1rem;
  border-radius: 12px;
  object-fit: cover;
  height: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    margin-top: 1.5rem;
    border-radius: 16px;
  }

  @media (min-width: 901px) {
    display: none;
  }
`;

export const Logo = styled.img`
  width: 140px;
  margin: auto;
  
  @media (max-width: 400px) {
    width: 120px;
  }

  @media (max-width: 360px) {
    width: 110px;
  }

  @media (min-width: 768px) {
    width: 180px;
    margin: 0 0 0.25rem 0;
  }

  @media (min-width: 901px) {
    width: 160px;
    margin-bottom: 0.25rem;
  }
`;

export const HeaderText = styled(Typography)`
  font-weight: bold !important;
  margin-bottom: 0.25rem !important;
  font-size: 1.5rem;
  line-height: 1.2;
  text-align: left;
  color: #0B4598;
  
  @media (max-width: 400px) {
    font-size: 1.35rem;
  }

  @media (max-width: 360px) {
    font-size: 1.25rem;
  }

  @media (min-width: 768px) and (max-width: 900px) {
    font-size: 1.75rem;
  }

  @media (min-width: 768px) {
    font-size: 1.875rem;
    margin-bottom: 0.375rem !important;
  }

  @media (min-width: 901px) {
    font-size: 1.875rem;
    margin-bottom: 0.25rem !important;
  }
`;

export const SubHeaderText = styled(Typography)`
  margin-bottom: 0.25rem !important;
  color: #555 !important;
  font-size: 0.875rem;
  line-height: 1.4;
  text-align: left;
  
  @media (max-width: 400px) {
    font-size: 0.8125rem;
  }

  @media (max-width: 360px) {
    font-size: 0.75rem;
    line-height: 1.3;
    margin-bottom: 0.125rem !important;
  }

  @media (min-width: 768px) and (max-width: 900px) {
    font-size: 0.9375rem;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
    margin-bottom: 0.375rem !important;
  }

  @media (min-width: 901px) {
    font-size: 1rem;
    margin-bottom: 0.25rem !important;
  }
`;

export const BenefitsList = styled(Box)`
  list-style: none;
  padding: 0;
  margin: 0.25rem 0;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #666;
  
  @media (max-width: 400px) {
    font-size: 0.8125rem;
    margin: 0.25rem 0;
  }

  @media (max-width: 360px) {
    font-size: 0.75rem;
    margin: 0.125rem 0;
  }

  & li {
    margin-bottom: 0.375rem;
    padding-left: 1rem;
    position: relative;
  }

  @media (max-width: 360px) {
    & li {
      padding-left: 0.75rem;
      margin-bottom: 0.25rem;
    }
  }

  & li:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #13CA82;
    font-weight: bold;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
    margin: 0.375rem 0;
    
    & li {
      margin-bottom: 0.375rem;
    }
  }

  @media (min-width: 901px) {
    font-size: 0.875rem;
    margin: 0.25rem 0;
    
    & li {
      margin-bottom: 0.375rem;
      font-size: 0.875rem;
    }
  }
`;

export const FeeText = styled(Typography)`
  font-size: 0.875rem;
  line-height: 1.4;
  color: #666;
  text-align: left;
  margin-bottom: 0.25rem;
  
  @media (max-width: 400px) {
    font-size: 0.8125rem;
    margin-bottom: 0.25rem;
  }

  @media (max-width: 360px) {
    font-size: 0.75rem;
    margin-bottom: 0.125rem;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
    margin-bottom: 0.375rem;
  }

  @media (min-width: 901px) {
    font-size: 0.875rem;
    margin-bottom: 0;
  }
`;

export const SignUpPrompt = styled(Typography)`
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.3;
  text-align: left;
  margin-bottom: 0;
  
  @media (max-width: 400px) {
    font-size: 1rem;
  }

  @media (max-width: 360px) {
    font-size: 0.9375rem;
  }

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }

  @media (min-width: 901px) {
    font-size: 1.25rem;
  }
`;

export const CreditCardText = styled.span`
  color: #000;
  font-weight: 400;
  font-size: 0.875rem;
  
  @media (min-width: 901px) {
    font-size: 0.875rem;
  }
`; 

export const SignInWrapper = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  @media (min-width: 768px) {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }

  @media (min-width: 901px) {
    text-align: left;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
`;

export const SignInText = styled(Typography)`
  font-size: 0.875rem;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

export const SignInLink = styled(Link)`
  cursor: pointer;
`;
